import axios, { AxiosResponse } from "axios";
import { RegisterAppUserDto } from "../../dto/register.dto";

export function registerAppUser(
  email: string,
  username: string,
  password: string,
  code: string,
  agreedPrivacyPolicy: boolean,
  agreedTermsOfUse: boolean,
  agreedTracking: boolean
): Promise<AxiosResponse<void>> {
  const payload: RegisterAppUserDto = {
    email,
    username,
    password,
    code,
    agreedPrivacyPolicy,
    agreedTermsOfUse,
    agreedTracking,
  };

  return axios.post("app-user/register", payload);
}

export function validateAppUser(
  code: string,
  externalUserId: string
): Promise<AxiosResponse<void>> {
  return axios.post("private/registration-code/validate", {
    code,
    externalUserId,
  });
}
